import { useMemo } from 'react'

import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'

const buildMockHistory = () => [
  {
    descripcion: 'Agustin Reynoso actualizó campos de la compactación',
    fecha: '26/04/2024 17:07',
  },
  {
    descripcion: 'Agustin Reynoso actualizó campos de la compactación',
    fecha: '26/04/2024 17:07',
  },
  {
    descripcion: 'Agustin Reynoso actualizó campos de la compactación',
    fecha: '26/04/2024 17:07',
  },
]

const HistorialContent = (props) => {
  const { data } = props

  const history = useMemo(() => {
    if (Array.isArray(data?.history) && data.history.length > 0) return data.history
    return buildMockHistory()
  }, [data])

  return <ComplexDialogHistory history={history} />
}

export default HistorialContent
